import React from 'react';
import type { ThemePalette } from '../../theme/tokens';
import { Ball } from './Ball';

export interface FreqBarProps {
  n: number;
  count: number;
  max: number;
  c: ThemePalette;
  highlight?: boolean;
}

export const FreqBar: React.FC<FreqBarProps> = ({ n, count, max, c, highlight = false }) => {
  const pct = (count / max) * 100;
  return (
    <div className="flex items-center gap-2.5">
      <Ball n={n} size={28} c={c} muted={!highlight} />
      <div
        className="relative flex-1 overflow-hidden rounded"
        style={{ height: 8, background: c.surfaceAlt, borderRadius: 4 }}
      >
        <div
          className="h-full rounded"
          style={{
            width: `${pct}%`,
            background: highlight ? c.accent : c.ink,
            borderRadius: 4,
          }}
        />
      </div>
      <div
        className="w-6 text-right font-mono text-[11px]"
        style={{ fontFamily: 'var(--font-mono)', color: c.inkMuted }}
      >
        {count}
      </div>
    </div>
  );
};
